/**
 * @description
 * Objeto StatisticsExternalFiltro
 */

export class StatisticsExternalFiltro {

    public rol: string;
    public nifinteressat: string;
    public nifrepresentant: string;
    public dateini: Date;
    public datefin: Date;

    constructor() {}
  
}